import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import { setSorteoInfo, selectSorteoInfo } from '../../slice/global';
import { CallApiGet, CallApiPost } from '../../apicalls/calls.js';
import Banqueo from './Banqueo.jsx';
import Linea from '../Graficas/linea.jsx';
import CerrarSorteo from './CerrarSorteo.jsx';
import Paginate from '../Parts/Paginate.jsx';
import ReporteFinal from './ReporteFinal.jsx';
import CantidadMaxima from './CantidadMaxima.jsx';


export default function Versorteo() {
    const { id_sorteo } = useParams();
    const UsuarioS = JSON.parse(window.localStorage.getItem('usuario'));
    const [tipos, SetTipoS] = useState(true);
    const dispatch = useDispatch();
    const State = useSelector(selectSorteoInfo);
    const [grafica, SetGrafica] = useState({
        labels: [],
        datasets: []
    });

    //Paginacion
    const [currentItems, setCurrentItems] = useState([]);
    const [pageCount, setPageCount] = useState(0);
    const [itemOffset, setItemOffset] = useState(0);
    const [filterNumber, setFilterNumber] = useState("");
    const [touchFilter, settouchFilter] = useState(false);

    const itemsPerPage = 10;


    //console.log(State)
    useEffect(() => {
        fetchData(1);
    }, []);

    useEffect(() => {
        return () => {
            $("#backdrop").hide();
        }
    }, [grafica]);

    const Save = async (values, actions) => {
        $("#backdrop").show();
        $('#addSorteo').modal('hide');
        var params = { id_sorteo: id_sorteo, tipo: '1', cantidad: values.cantidad, sorteo_tipo: tipos ? 1 : 2 };
        const res = await CallApiPost('accionesInfoSorteo', params, UsuarioS.access_token);
        //console.log("estatus", res.status);
        if (res.status != 200) {
            alert("error al momento de guardar");
        } else {
            await fetchData(tipos ? 1 : 2);
            actions.resetForm();
            //$('#addSorteo').modal('hide');
        }
    }

    //Metodo para hacer la llamada a la API
    async function fetchData(tipo) {
        $("#backdrop").show();
        var params = { id_sorteo: id_sorteo, tipo: tipo, filter_number: filterNumber };
        //console.log("params", params);
        CallApiGet('getInfoSorteo', params, UsuarioS.access_token).then((e)=>{
            dispatch(setSorteoInfo(e.success.sorteos));
            //Paginacion
            if (touchFilter)
                setItemOffset(0);
            const endOffset = itemOffset + itemsPerPage;
            setCurrentItems(e.success.sorteos.tabla_registros.slice(itemOffset, endOffset));
            setPageCount(Math.ceil(e.success.sorteos.tabla_registros.length / itemsPerPage));
        });
        
        var type = !tipos;
        UpdateGrafica(type ? 2 : 1, itemOffset);
        settouchFilter(false);
        //$("#backdrop").hide();
    }

    const ActionNumber = async (id, numero, tipo) => {
        window.Swal.fire({
            title: `¿Está seguro de ${tipo == 1 ? 'bloquear' : 'activar'} el número seleccionado?`,
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Aceptar',
            cancelButtonText: 'Cancelar',
        }).then(async (result) => {
            if (result.isConfirmed) {
                $("#backdrop").show();
                var params = { id_sorteo: id_sorteo, tipo: '2', id_bloq: id, numero: numero, sorteo_tipo: tipos ? 1 : 2 };
                const res = await CallApiPost('accionesInfoSorteo', params, UsuarioS.access_token);
                //console.log("estatus", res.status);
                if (res.status != 200) {
                    alert("error al momento de guardar");
                } else {
                    await fetchData(tipos ? 1 : 2);
                    //$("#backdrop").hide();
                }

            }
        })
    }


    const Close = async () => {
        if (State.numeros_ganadores?.numero1 && State.numeros_ganadores.numero1 != null) {
            window.Swal.fire({
                title: `¿Está seguro de cerrar el sorteo?`,
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Aceptar',
                cancelButtonText: 'Cancelar',
            }).then(async (result) => {
                if (result.isConfirmed) {
                    //alert("Cerrar sorteo");
                    $("#backdrop").show();
                    var params = { id: id_sorteo, tipo: '2' };
                    const res = await CallApiPost('accionesSorteos', params, UsuarioS.access_token);
                    //console.log("estatus", res.status);
                    if (res.status != 200) {
                        $("#backdrop").hide();
                        alert("error al momento de guardar");
                        // $('#SorteoFin').modal('hide');
                    } else {
                        await fetchData(1);
                        //actions.resetForm();
                        //$('#SorteoFin').modal('hide');
                    }
                }
            });

        } else {
            window.Swal.fire({
                icon: 'error',
                title: 'Alerta',
                text: "No se han guardado números ganadores",
            });
        }

    }

    const SaveNumGan = async (values, actions) => {
        var params = { id: id_sorteo, tipo: '3', numero1: values.numero1, numero2: values.numero2 };
        const res = await CallApiPost('accionesSorteos', params, UsuarioS.access_token);
        //console.log("estatus", res.status);
        if (res.status != 200) {
            $("#backdrop").hide();
            //alert("error al momento de guardar");
            $('#SorteoFin').modal('hide');
        } else {
            await fetchData(1);
            actions.resetForm();
            $('#SorteoFin').modal('hide');
        }
    }

    async function OnchangeSorteo() {
        if (State.info_sorteo.multiple) {
            var param = !tipos;
            await SetTipoS(!tipos);
            await fetchData(param ? 1 : 2);
            await UpdateGrafica(param ? 1 : 2, itemOffset);
        }
    }

    async function UpdateGrafica(tipos, offset) {
        //$("#backdrop").show();
        var params = { id_sorteo: id_sorteo, tipo: tipos, offset: offset, filter_number: filterNumber };
        CallApiGet('getTablaInfoSorteo', params, UsuarioS.access_token).then((e)=>{
            SetGrafica(e.success.sorteo);
        });
       
    }


    //Paginacion
    useEffect(() => {
        // Fetch items from another resources.
        const endOffset = itemOffset + itemsPerPage;
        //console.log(`Loading items from ${itemOffset} to ${endOffset}`);
        setCurrentItems(State.tabla_registros.slice(itemOffset, endOffset));
        setPageCount(Math.ceil(State.tabla_registros.length / itemsPerPage));
    }, [itemOffset, itemsPerPage]);

    // Invoke when user click to request another page.
    const handlePageClick = async (event) => {
        const newOffset = (event.selected * itemsPerPage) % State.tabla_registros.length;
        //console.log("offset", newOffset);
        setItemOffset(newOffset);
        var param = !tipos;
        await UpdateGrafica(param ? 2 : 1, newOffset);
    };

    const OnchangeFilterNumber = (e) => {
        const re = /^[0-9\b]+$/;
        if (e.target.value === '' || re.test(e.target.value)) {
            setFilterNumber(e.target.value);
            settouchFilter(true);
        }
    }

    const FilterNumber = async () => {
        await fetchData(tipos ? 1 : 2);
    }

    const TestNav = async () => {
        //await fetchData(tipos ? 1 : 2);
    }

    const SaveCantidadMaxima= async (values,actions)=>{
        var params = { sorteo_id: id_sorteo, cantidad: values.cantidad };
        const res = await CallApiPost('addCantidadMaxima', params, UsuarioS.access_token);
        //console.log("estatus", res.status);
        if (res.status != 200) {
            $("#backdrop").hide();
            //alert("error al momento de guardar");
            $('#addCantidadMaxima').modal('hide');
        } else {
            await fetchData(1);
            actions.resetForm();
            $('#addCantidadMaxima').modal('hide');
        }
    }

    return (
        <div className='container-fluid'>
            <div className="d-sm-flex align-items-center justify-content-between mb-4">
                <h1 className="h3 mb-0 text-gray-800">Panel del sorteo:  {State.info_sorteo.nombre}</h1>
                <div className="btn-group" role="group" aria-label="Basic example">
                    {/* <a href={`${process.env.BASEURL}/captura/registros/` + id_sorteo} className={'btn btn-sm m-1 text-white'} style={{ background: "#E1C34C" }}>Capturas</a> */}
                    <a className={`btn ${!tipos ? 'btn-success' : 'btn-danger'} btn-sm m-1 text-white `}  onClick={(e) => OnchangeSorteo(e)}  >Cambiar de sorteo</a>

                    {/* <a href={`${process.env.URLAPI}reporteBanqueo/${State.info_sorteo.id}/${tipos ? '1' : '2'}`} target="_blank" className={`btn ${!tipos && 'btn-success'} btn-sm m-1 text-white`} style={{ background: tipos && "#E1C34C" }}>Pase {tipos ? 'primer' : 'segundo'} lugar</a> */}
                    {/*  <a href={`https://api.ticc.com.mx/api/reporteBanqueo/${State.info_sorteo.id}/2`} target="_blank" className="btn btn-primary btn-sm m-1">Banqueo sorteo 2</a> */}

                    {/*  <button onClick={() => $('#addSorteo').modal('show')} className={`btn ${!tipos && 'btn-success'} btn-sm m-1 text-white`} style={{ background: tipos && "#E1C34C" }} >
                        <i className="fas fa-plus fa-sm text-white-50"></i> Banquear cantidad
                    </button> */}
                    <div className="dropdown">
                        <button /* className="btn btn-primary dropdown-toggle" */ className={`btn ${!tipos ? 'btn-success' : 'btn-danger'} btn-sm m-1 text-white dropdown-toggle`} id="dropdownMenuButton" type="button" data-bs-toggle="dropdown" aria-haspopup="true" aria-expanded="false">Opciones Sorteo</button>
                        <div className="dropdown-menu" aria-labelledby="dropdownMenuButton">
                            <a className="dropdown-item" style={{cursor:'pointer'}} href={`${process.env.BASEURL}/captura/registros/` + id_sorteo}><i className="fa fa-calculator"></i> Capturas</a>
                            <a className="dropdown-item" style={{cursor:'pointer'}} href={`${process.env.URLAPI}reporteBanqueo/${State.info_sorteo.id}/${tipos ? '1' : '2'}`}><i className="fa fa-star"></i> Pase {tipos ? 'primer' : 'segundo'} lugar</a>
                            <a className="dropdown-item" style={{cursor:'pointer'}} onClick={() => $('#addSorteo').modal('show')}><i className="fa fa-times-circle"></i> Banquear Cantidad</a>
                            <a className="dropdown-item" style={{cursor:'pointer'}} onClick={() => $('#addCantidadMaxima').modal('show')}><i className="fa fa-plus-circle"></i> Cantidad Maxima</a>
                            {State.info_sorteo.estatus!="FINALIZADO" &&(
                                <a className="dropdown-item" style={{cursor:'pointer'}} onClick={() => $('#SorteoFin').modal('show')}><i className="fa fa-trophy"></i> Numeros Ganadores</a>
                            )}
                        </div>
                    </div>
                    {State.info_sorteo.estatus != "FINALIZADO" && (
                        <>
                            {/*  <button className={`btn btn-success btn-sm m-1 text-white`} onClick={() => $('#SorteoFin').modal('show')}>Num Ganandores</button> */}
                            <button className="btn btn-danger btn-sm m-1" onClick={() => Close()}>Cerrar sorteo</button>
                        </>
                    )}

                    {State.info_sorteo.estatus == "FINALIZADO" && (
                        <>
                            {/* <a href={`http://localhost/qa.lumen/api/getReporteFinal/${State.info_sorteo.id}/${State.numeros_ganadores.numero1}/${State.numeros_ganadores.numero2}`} target="_blank" className="btn btn-warning btn-sm m-1">Resultados sorteo</a> */}
                            <a onClick={() => $("#reporte").modal('show')} className="btn btn-warning btn-sm m-1">Resultados sorteo</a>
                        </>
                    )}
                </div>
                {/*     {State.info_sorteo.estatus != 0 && (
                    <a onClick={() => $('#addSorteo').modal('show')}
                        className="d-sm-inline-block btn btn-sm btn-primary shadow-sm">
                        <i className="fas fa-plus fa-sm text-white-50"></i> Banquear cantidad
                    </a>
                )} */}
            </div>

            <div className='row'>
                <div className="col-xl-3 col-md-3 mb-3">
                    <div className={`card border-left-${tipos ? 'primary' : 'success'} shadow h-100 py-2`}>
                        <div className="card-body">
                            <div className="row no-gutters align-items-center">
                                <div className="col mr-2">
                                    <div className={`text-xs font-weight-bold text-${tipos ? 'primary' : 'success'} text-uppercase mb-1`}>
                                        Total Vendido</div>
                                    <div className="h5 mb-0 font-weight-bold text-gray-800">${State.total_vendido}</div>
                                </div>
                                <div className="col-auto">
                                    <i className="fas fa-dollar-sign fa-2x text-gray-300"></i>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="col-xl-3 col-md-3 mb-3">
                    <div className={`card border-left-${tipos ? 'primary' : 'success'} shadow h-100 py-2`}>
                        <div className="card-body">
                            <div className="row no-gutters align-items-center">
                                <div className="col mr-2">
                                    <div className={`text-xs font-weight-bold text-${tipos ? 'primary' : 'success'} text-uppercase mb-1`}>
                                        Total Banqueado</div>
                                    <div className="h5 mb-0 font-weight-bold text-gray-800">${parseFloat(State.banqueo) > 0 ? State.total_banqueo : 0}</div>
                                </div>
                                <div className="col-auto">
                                    <i className="fas fa-dollar-sign fa-2x text-gray-300"></i>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="col-xl-3 col-md-3 mb-3">
                    <div className={`card border-left-${tipos ? 'primary' : 'success'} shadow h-100 py-2`}>
                        <div className="card-body">
                            <div className="row no-gutters align-items-center">
                                <div className="col mr-2">
                                    <div className={`text-xs font-weight-bold text-${tipos ? 'primary' : 'success'} text-uppercase mb-1`}>
                                        Total de números vendidos</div>
                                    <div className="h5 mb-0 font-weight-bold text-gray-800">{State.total_numeros}</div>
                                </div>
                                <div className="col-auto">
                                    <i className="fas fa-comments fa-2x text-gray-300"></i>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="col-xl-3 col-md-3 mb-3">
                    <div className={`card border-left-${tipos ? 'primary' : 'success'} shadow h-100 py-2`}>
                        <div className="card-body">
                            <div className="row no-gutters align-items-center">
                                <div className="col mr-2">
                                    <div className={`text-xs font-weight-bold text-${tipos ? 'primary' : 'success'} text-uppercase mb-1`}>
                                        Cantidad banqueada</div>
                                    <div className="h5 mb-0 font-weight-bold text-gray-800">${State.banqueo}</div>
                                </div>
                                <div className="col-auto">
                                    <i className="fas fa-comments fa-2x text-gray-300"></i>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                
            </div>
            <div className='row'>
                <div className="col-sm-4 col-md-4 col-lg-4">
                    <div className="form-group" style={{ paddingTop: '30px' }}>
                        {/* <label htmlFor="exampleInputEmail1">Nombre:</label> */}
                        <input type="text" name='filter_number' className='form-control form-control-sm' placeholder='Busqueda de Número' maxLength={3} value={filterNumber || ''} onChange={(e) => OnchangeFilterNumber(e)} />
                    </div>
                </div>
                <div className="col-sm-8 col-md-8 col-lg-8">
                    <div className="form-group" style={{ paddingTop: '30px' }}>
                        <button type='submit' className='btn btn-primary btn-sm mt-30' onClick={() => FilterNumber()}>Filtrar</button>
                    </div>
                </div>
            </div>
            <div className='row'>
                <div className='col-xl-12 col-lg-12'>
                    <div className="card shadow mb-4">
                        <div className={`card-header py-3 ${tipos ? 'bg-gradient-primary' : 'bg-gradient-success'}`} onClick={(e) => OnchangeSorteo(e)} style={{ cursor: 'pointer' }}>
                            <h6 className="m-0 font-weight-bold text-white">Gráfica de concentrados</h6>
                        </div>
                        <div className="card-body">
                            <Linea Data={grafica} />
                            {/* <Linea Data={State.grafica} /> */}
                        </div>
                    </div>
                </div>

            </div>
            <div className="card shadow mb-4">
                <div className={`card-header py-3 ${tipos ? 'bg-gradient-primary' : 'bg-gradient-success'}`} onClick={(e) => OnchangeSorteo(e)} style={{ cursor: 'pointer' }}>
                    <div className='row'>
                        <div className='col-6'>
                            <h6 className="m-0 font-weight-bold text-white">Tabla de concentrados: Sorteo {tipos ? 1 : 2}</h6>
                        </div>
                        <div className='col-6 text-right text-white'>
                            <i className="fa fa-arrow-circle-left fa-lg" aria-hidden="true"></i>
                        </div>
                    </div>
                </div>
                <div className="card-body">
                    <div className="table-responsive">
                        <table className="table table-bordered" id="dataTable" width="100%" cellSpacing="0">
                            <thead>
                                <tr>
                                    <th>Número</th>
                                    <th>Acumulado</th>
                                    <th>Saldo</th>
                                    <th>Acciones</th>
                                </tr>
                            </thead>
                            <tbody style={{ maxHeight: '400px', overflow: 'auto' }}>
                                {currentItems.length == 0 && (
                                    <tr className='text-center'><td colSpan={5}>No hay registros de captura.</td></tr>
                                )}
                                {currentItems && currentItems.map((item, key) => (
                                    <tr key={key}>
                                        <td>{item.numero}</td>
                                        <td>{item.cantidad}</td>
                                        <td>{parseInt(item.cantidad) > State.banqueo ? parseInt(item.cantidad) - State.banqueo : 0}</td>
                                        {State.info_sorteo.estatus != 0 && (
                                            <td className="text-center">
                                                {item.id == null ?
                                                    <button className="btn btn-danger btn-circle btn-sm" onClick={() => ActionNumber(item.id, item.numero, 1)} data-bs-toggle="tooltip" data-bs-placement="top" title="Bloquear número" ><i className="fa fa-ban"></i></button> :
                                                    <button className="btn btn-warning btn-circle btn-sm" onClick={() => ActionNumber(item.id, item.numero, 2)} data-bs-toggle="tooltip" data-bs-placement="top" title="Activar número" ><i className="fa fa-exclamation-triangle"></i></button>}
                                            </td>
                                        )}
                                        {State.info_sorteo.estatus == 0 && (
                                            <td className="text-center">
                                            </td>
                                        )}
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                    <div className='float-md-right'>
                        <Paginate handlePageClick={handlePageClick} pageCount={pageCount} />
                    </div>
                </div>
            </div>
            <Banqueo Banqueo={State.banqueo} Save={Save} Tipo={tipos} />
            <CantidadMaxima  Cantidad={State.cantidad_maxima} Save={SaveCantidadMaxima} Tipo={tipos}/>
            <CerrarSorteo Close={SaveNumGan/* Close */} Tipo={State.info_sorteo.multiple} NumerosG={State.numeros_ganadores} />
            {State.info_sorteo.estatus == "FINALIZADO" && (
                <ReporteFinal Sorteo={State.info_sorteo.id} N1={State.numeros_ganadores.numero1} N2={State.numeros_ganadores.numero2} />
            )}

        </div>
    )
}
